export const a4PrintConfig = `
  @page {
    size: A4 portrait;
    margin: 0mm 12mm 0mm 12mm;
  }
  @media print {
    html,
    body {
      margin: 0;
      padding: 0;
      overflow: visible !important;
      background: #fff !important;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
      color-adjust: exact;
    }
    .prescription-print-root.print-container {
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
      margin: 0;
      padding: 0 !important;
      background: #fff !important;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
    /* thead repeats at top each page; footer is fixed to physical bottom (see .prescription-print-footer-pin) */
    .prescription-print-root .prescription-print-layout {
      width: 100%;
      max-width: 100%;
      border-collapse: separate;
      border-spacing: 0;
      table-layout: fixed;
    }
    .prescription-print-root thead {
      display: table-header-group;
    }
    .prescription-print-root thead tr {
      break-inside: avoid;
      page-break-inside: avoid;
    }
    .prescription-print-root .prescription-print-thead-cell {
      padding: 0 0 10px 0;
      vertical-align: top;
    }
    .prescription-print-root .prescription-print-tbody-cell {
      padding: 8px 0 10px;
      vertical-align: top;
    }
    /* Last tbody row: keep with content above; avoid tall unbreakable row (was pushing sign alone to next page). */
    .prescription-print-root tr.prescription-print-sign-last-row {
      break-before: avoid;
      page-break-before: avoid;
    }
    .prescription-print-root .prescription-print-tbody-cell.prescription-print-sign-last {
      padding-top: 2mm;
      padding-bottom: 18mm;
      vertical-align: bottom;
      box-sizing: border-box;
    }
    .prescription-print-root .prescription-print-sign-inner {
      break-inside: avoid;
      page-break-inside: avoid;
    }
    .prescription-print-root .prescription-print-doc-header {
      padding: 10px 8px 12px;
      margin: 0;
      text-align: center;
      box-sizing: border-box;
      break-inside: avoid;
      page-break-inside: avoid;
    }
    .prescription-print-root .prescription-print-doc-footer.prescription-print-footer-pin {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      padding: 6px 5mm 0;
      margin: 0;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-start;
      text-align: left;
      box-sizing: border-box;
      background: #fff;
      z-index: 9999;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
      break-inside: avoid;
      page-break-inside: avoid;
    }
    .prescription-print-root .prescription-print-footer-inner {
      width: 100%;
      box-sizing: border-box;
    }
    .prescription-print-root .prescription-print-footer-doctor-name {
      margin-left: 0 !important;
    }
    .prescription-print-root
      .prescription-print-doc-footer.prescription-print-footer-pin
      .prescription-print-footer-disclaimer {
      align-self: center;
      width: 100%;
      text-align: center;
    }
    .prescription-print-root .prescription-print-footer-pin img {
      display: block;
      margin: 0;
      width: 100%;
      max-width: 100%;
      height: auto;
      vertical-align: bottom;
      object-fit: contain;
      object-position: bottom center;
    }
    .prescription-print-root .prescription-print-body-inner {
      padding: 2px 0 8px;
      box-sizing: border-box;
    }
    .prescription-print-root .prescription-print-patient-block,
    .prescription-print-root .prescription-print-top-block,
    .prescription-print-root .prescription-print-row,
    .prescription-print-root .prescription-print-col-head {
      break-inside: avoid;
      page-break-inside: avoid;
    }
    /* Long notes (discharge reports, etc.) must split across pages or page 1 is left empty */
    .prescription-print-root .prescription-print-notes {
      break-inside: auto;
      page-break-inside: auto;
    }
    .prescription-print-root .prescription-print-row,
    .prescription-print-root .prescription-print-col-head {
      display: grid !important;
      grid-template-columns:
        minmax(0, 25fr)
        minmax(0, 12fr)
        minmax(0, 13fr)
        minmax(0, 10fr)
        minmax(0, 10fr)
        minmax(0, 15fr)
        minmax(0, 15fr);
      column-gap: 5px;
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
    }
    .prescription-print-root .prescription-print-cell {
      min-width: 0;
      max-width: 100%;
      overflow-wrap: anywhere;
      word-break: break-word;
    }
    .prescription-print-root img {
      max-width: 100%;
      break-inside: avoid;
      page-break-inside: avoid;
    }
    /* Scoped only to FileView / BodyMapView — does not affect clinic logo, footer, or other print images */
    .prescription-print-root .file-view-root .file-view-item,
    .prescription-print-root .body-map-view-root .body-map-item {
      page-break-inside: avoid;
      break-inside: avoid;
    }
    .prescription-print-root .file-view-root .file-view-image,
    .prescription-print-root .body-map-view-root .body-map-image {
      display: block !important;
      width: 40px !important;
      height: 40px !important;
      max-width: 40px !important;
      max-height: 40px !important;
      object-fit: contain !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
    .prescription-print-root .blue-box-examD,
    .prescription-print-root .p5 {
      break-inside: auto;
      page-break-inside: auto;
    }
    .prescription-print-root p,
    .prescription-print-root .MuiTypography-root {
      orphans: 3;
      widows: 3;
    }
    .print-container {
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
      margin: 0;
      padding: 0;
    }
    .prescription-print-hide-in-pdf {
      display: none !important;
    }
  }
`;
